var _defs, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _polyline, _polygon6, _polygon7, _polygon8;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobRadienShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 706.65 706.65",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #d9faff;\n      }\n\n      .cls-2 {\n        fill: #f98fff;\n      }\n\n      .cls-3 {\n        fill: #b1e1e5;\n      }\n\n      .cls-4 {\n        fill: aqua;\n      }\n\n      .cls-5 {\n        fill: #c9ecf2;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "475.12 384.18 440.11 389.43 367.24 389.43 367.24 327.41 475.12 343.62 475.12 384.18"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "493.71 313.71 236.16 344.3 151.57 374.76 429.33 374.76 493.71 313.71"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "424.62 385.66 184.87 385.66 151.12 374.3 427.27 374.3 424.62 385.66"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "416.78 411.2 237.08 400.92 237.08 395.8 416.78 384.62 416.78 411.2"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "466.41 415.94 325.5 413.02 261.4 374.03 429.9 374.03 466.41 415.94"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "236.16 343.39 537.88 273.56 493.2 313.97"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "236.16 343.39 150.88 374.89 217.06 374.89 446.92 294.48 236.16 343.39"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "499.68 433.09 306.04 430.48 279.59 412.58 484.14 415.94 499.68 433.09"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "289.14 373.98 217.28 374.89 446.92 294.48 289.14 373.98"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobRadienShip);
export default __webpack_public_path__ + "static/media/mob-radien-ship.8774e49b33e0ce7fbecdf0d551dd7732.svg";
export { ForwardRef as ReactComponent };